import { ServiceSettingContinuousRecordPageStore } from './service-setting-continuous-record-page.store';
import { Component } from '@angular/core';
import {
    SERVICE_SETTINGS_CONTINUOUS_RECORD_TYPE_KEY,
} from '@libs/types/src/services/types/common-service-settings.type';
import {
    ServiceSettingsCommonComponent,
} from '../../../../modules/content/components/services/settings/service-settings-common/service-settings-common.component';

@Component({
    selector: 'app-service-setting-continuous-record-page',
    templateUrl: './service-setting-continuous-record-page.component.html',
    styleUrl: './service-setting-continuous-record-page.component.scss',
    providers: [ServiceSettingContinuousRecordPageStore],
    imports: [
        ServiceSettingsCommonComponent,
    ],
})
export class ServiceSettingContinuousRecordPageComponent {

    protected readonly SERVICE_SETTINGS_CONTINUOUS_RECORD_TYPE_KEY = SERVICE_SETTINGS_CONTINUOUS_RECORD_TYPE_KEY;

}
